import { Loader } from '@nv/basic-components'
import { useAdminUserContext, useVoterUserContext } from '@nv/contexts'
import { Navigate } from 'react-router-dom'

export const VerifyUserGuard = ({ component: WrappedComponent, redirectURL = '/' }) => {
  const { adminUser, authChecked: adminAuthChecked } = useAdminUserContext()
  const { voterUser, authChecked: voterAuthChecked } = useVoterUserContext()

  if (!adminAuthChecked && !voterAuthChecked) return <Loader />

  if ((!adminUser?.username && adminAuthChecked) || (!voterUser?.username && voterAuthChecked)) return <Navigate to={redirectURL} replace />
  else return <WrappedComponent />
}
